import { FASTElement as g, attr as n } from "@microsoft/fast-element";
import { dataGridStyles as _ } from "./data-grid.styles.js";
import { dataGridTemplate as m } from "./data-grid.template.js";
import { JsonValueConverter as p } from "../common/converters/json-value-converter.js";
import { TableMixin as k } from "../table/table-mixin.js";
import { applyMixins as b } from "../common/apply-mixins.js";
import { forceUpdate as a } from "../common/force-update.js";
var u = Object.defineProperty, h = (d, e, t, s) => {
  for (var i = void 0, r = d.length - 1, c; r >= 0; r--)
    (c = d[r]) && (i = c(e, t, i) || i);
  return i && u(e, t, i), i;
};
const f = class f extends g {
  constructor() {
    super(...arguments), this._cache = {}, this.columns = [], this.rows = [], this.checkboxSelection = !1, this.pagination = {
      total: 0,
      page: 0,
      pageSize: 0,
      pageSizeOptions: []
    };
  }
  rowsChanged() {
    this.$fastController.isConnected && a(this);
  }
  get showPagination() {
    return this.pagination.total > 0 && this.pagination.page && this.pagination.page > 0;
  }
  get allChecked() {
    return this.rows.length > 0 && this.rows.every((e) => e.__checked);
  }
  get isIndeterminate() {
    return this.rows.some((e) => e.__checked) && !this.allChecked;
  }
  get checkedRows() {
    return this.rows.filter((e) => e.__checked);
  }
  checkboxSelectionChanged(e, t) {
    t ? this.classList.add("checkbox-selection") : this.classList.remove("checkbox-selection");
  }
  connectedCallback() {
    super.connectedCallback(), this.variant || (this.variant = "zebra");
  }
  selectRow(e) {
    e.__checked = !e.__checked, this.$emit("checkbox-selection", this.checkedRows, {
      cancelable: !1
    }), a(this);
  }
  toggleAllRows() {
    const e = !this.allChecked;
    for (const t of this.rows)
      t.__checked = e;
    this.$emit("checkbox-selection", this.checkedRows, {
      cancelable: !1
    }), a(this);
  }
  sortByColumn(e) {
    if (!e.sortable)
      return;
    const t = this.getSortDirection(e.id);
    this._cache[e.id] || (this._cache[e.id] = {});
    for (const i of Object.keys(this._cache))
      delete this._cache[i].sort;
    const s = this._cache[e.id];
    t ? t === "asc" ? s.sort = "desc" : delete s.sort : s.sort = "asc", this.$emit(
      "sort",
      { column: e, sort: s.sort },
      {
        cancelable: !1
      }
    ), a(this);
  }
  getTableCellAlignment(e) {
    var r, c;
    if ((r = this._cache[e]) != null && r.align)
      return this._cache[e].align;
    this._cache[e] || (this._cache[e] = {});
    const t = this._cache[e], s = this.columns.find((l) => l.id === e);
    if (s != null && s.align)
      return t.align = s.align;
    let i;
    return typeof (s == null ? void 0 : s.type) == "string" ? i = s.type : i = (c = this.rows.find((l) => l[e] !== void 0)) == null ? void 0 : c[e], typeof i == "number" ? t.align = "right" : t.align = "left";
  }
  getSortDirection(e) {
    var t;
    return (t = this._cache[e]) == null ? void 0 : t.sort;
  }
  getSortIcon(e) {
    var t;
    return ((t = this._cache[e]) == null ? void 0 : t.sort) === "desc" ? "arrow-small-down" : "arrow-small-up";
  }
};
f.definition = {
  name: "data-grid",
  template: m,
  styles: _,
  attributes: ["variant"]
};
let o = f;
h([
  n({
    converter: p
  })
], o.prototype, "columns");
h([
  n({
    converter: p
  })
], o.prototype, "rows");
h([
  n({ mode: "boolean", attribute: "checkbox-selection" })
], o.prototype, "checkboxSelection");
h([
  n({
    converter: p
  })
], o.prototype, "pagination");
b(o, k);
export {
  o as DataGrid
};
